export default __webpack_public_path__ + "static/media/COC_for_Directors_and_Senior_Management_2.c89d5fc9.pdf";